export default {"src":"/_next/static/media/linkedin-green.b49014cc.svg","height":24,"width":24};